import {Button} from '@material-ui/core';
import React from 'react';
import Modal from 'Shared/components/Modal';
import {cancelBrokerSpreadsheetUpload} from 'Enrollment/ducks/enrollmentFileProcessing';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {EnrollmentFileStatusType} from 'Enrollment/models/EnrollmentFileStatusType';

export type BrokerSpreadsheetCancelConfirmationModalProps = {
  onClose: () => void;
  fileId: string;
};


const BrokerSpreadsheetCancelConfirmationModal = (props: BrokerSpreadsheetCancelConfirmationModalProps) => {
  const {onClose} = props;
  const dispatch = useDispatch();  
  const fileStatusId = EnrollmentFileStatusType.CANCELED;  

  const {externalUploadQueueFilters} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);
  
  const handleRemoveEnrollmentApplication = () => {       
      dispatch(
        cancelBrokerSpreadsheetUpload(props.fileId, fileStatusId, externalUploadQueueFilters, undefined)
      );    
    onClose();
  };

  return (
    <Modal open onClose={onClose} title="Cancel Confirmation">
      <div className="enrollment-file-rejects-modal">
        <h4>Are you sure you would like to cancel this file upload?</h4>       
        <div className="modal__footer modal__footer-enrollment-file-rejects">
          <Button className="modal__footer-enrollment-file-rejects-actions" variant="contained" onClick={onClose}>
            Close
          </Button>
          <Button
            className="modal__footer-enrollment-file-rejects-actions"
            color="primary"
            variant="contained"            
            onClick={handleRemoveEnrollmentApplication}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BrokerSpreadsheetCancelConfirmationModal;
